import Summary from "./formats/summary"
import Processing from "./formats/processing"
import Action from "./formats/action"

export default {
  summary: Summary,
  processing: Processing,
  action: Action
}
